import { TextOrHTML } from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";
import { useMemo } from "react";
import type { Locale } from "../../../types";
import { ambles } from "../../../content/ambles";
import { getAmble } from "./getAmble";

export type AmbleElement = HTMLDivElement;

export type AmbleProps = {
  className?: string;
  amble?: string;
  ambleName?: string;
  site: string;
  locale: Locale;
};

/**
 * Amble component for questionnaires.
 * Renders direct amble content and/or registry lookup by ambleName.
 */
export const Amble = ({
  className,
  amble,
  ambleName,
  site,
  locale,
}: AmbleProps) => {
  const content = useMemo(() => {
    if (amble) return amble;
    if (ambleName) return getAmble({ ambleName, site, locale, ambles });
    return undefined;
  }, [amble, ambleName, site, locale]);

  if (!content) {
    return null;
  }

  return (
    <TextOrHTML
      htmlClassName={classNames("mobius-amble", className)}
      text={content}
      textWrapper
    />
  );
};

Amble.displayName = "Amble";
